import { useCallback } from 'react';
import { useIntl } from 'react-intl';
const useTranslationAvailability = () => {
    const intl = useIntl();
    const isTranslationAvailable = useCallback((translationKey) => {
        const translated = intl.formatMessage({ id: translationKey });
        return translated.trim() !== '' && translated !== translationKey;
    }, [intl]);
    return { isTranslationAvailable };
};
export default useTranslationAvailability;
//# sourceMappingURL=useTranslationAvailability.js.map